'use strict';
import angular from 'angular';
import './widget.am5.directives';
import './widget.am5.ctrls';

angular.module('widget.am5', [
    'widget.am5.directives',
    'widget.am5.ctrls',
]);
